<section class="wish-section" aria-labelledby="wishTitle">
  <div class="wish-shell">
    <div class="wish-head">
      <div class="wish-copy">
        <h2 id="wishTitle">想要什么，你来定</h2>
        <p class="wish-subtitle">没有找到心仪的会员？提交心愿，巴士实现。</p>
      </div>
      <!-- <span class="wish-category">全部分类</span> -->
    </div>
    <div class="wish-board">
      <form class="wish-submit" (submit)="onWishSubmit(wishInput, $event)">
        <div class="wish-form-title">提交自己想要的</div>
        <p class="wish-form-desc">填写平台或产品名称，我们会认真记录并评估。</p>
        <div class="wish-input-row">
          <input
            class="wish-input"
            #wishInput
            type="text"
            maxlength="40"
            autocomplete="off"
            placeholder="输入平台的名称"
            aria-label="输入平台的名称"
          />
          <button class="wish-submit-btn" type="submit" [disabled]="submitting">
            {{ submitting ? "提交中..." : "提交心愿" }}
          </button>
        </div>
      </form>
      <div class="wish-display">
        <div class="wish-list-head">
          <div class="wish-list-title">其他用户想要的</div>
          <!-- <span class="wish-list-label">{{ wishListLabel }}</span> -->
        </div>
        <div class="wish-list">
          <span class="wish-item" *ngFor="let item of currentWishes">{{
            item.platform_name
          }}</span>
        </div>
      </div>
    </div>
  </div>
</section>
